// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILogoInfoDto
 */
export interface ILogoInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ILogoInfoDto
     */
    large_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ILogoInfoDto
     */
    minimized_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ILogoInfoDto
     */
    dark_large_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ILogoInfoDto
     */
    dark_minimized_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ILogoInfoDto
     */
    favicon_url?: string;
}

/**
 * Check if a given object implements the ILogoInfoDto interface.
 */
export function instanceOfILogoInfoDto(value: object): value is ILogoInfoDto {
    return true;
}

export function ILogoInfoDtoFromJSON(json: any): ILogoInfoDto {
    return ILogoInfoDtoFromJSONTyped(json, false);
}

export function ILogoInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILogoInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'large_logo_url': json['large_logo_url'] == null ? undefined : json['large_logo_url'],
        'minimized_logo_url': json['minimized_logo_url'] == null ? undefined : json['minimized_logo_url'],
        'dark_large_logo_url': json['dark_large_logo_url'] == null ? undefined : json['dark_large_logo_url'],
        'dark_minimized_logo_url': json['dark_minimized_logo_url'] == null ? undefined : json['dark_minimized_logo_url'],
        'favicon_url': json['favicon_url'] == null ? undefined : json['favicon_url'],
    };
}

export function ILogoInfoDtoToJSON(json: any): ILogoInfoDto {
    return ILogoInfoDtoToJSONTyped(json, false);
}

export function ILogoInfoDtoToJSONTyped(value?: ILogoInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'large_logo_url': value['large_logo_url'],
        'minimized_logo_url': value['minimized_logo_url'],
        'dark_large_logo_url': value['dark_large_logo_url'],
        'dark_minimized_logo_url': value['dark_minimized_logo_url'],
        'favicon_url': value['favicon_url'],
    };
}

